import { render } from "./table-leaderboard.vue?vue&type=template&id=2bf60561&ts=true"
import script from "./table-leaderboard.vue?vue&type=script&lang=ts"
export * from "./table-leaderboard.vue?vue&type=script&lang=ts"

import "./table-leaderboard.vue?vue&type=style&index=0&id=2bf60561&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__